import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { AlertController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

@Injectable()
export class LoginServiceProvider {

  // private mensagem: Array<any>;
  // private url: string = 'http://diskmedpadua.no-ip.org:8084/rest/gmlogin';

  constructor(private httpClient: HttpClient) {

  }

  fetchData(url: string, username: string, password: string) {

    // let alertctrl = this.alertCtrl.create({
    //   title: 'Falha no Login',
    //   subTitle: 'Falha no Login',
    //   buttons: ['Fechar']
    // });

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Basic ' + btoa(username + ":" + password),
        'UserKey':  'Basic ' + btoa(username + ":" + password)
      })
    };

    return this.httpClient.get<any>(url, httpOptions);

    // return new Promise(resolve => {
    //   return this.httpClient.get<any>(this.url, httpOptions).map(res => res.json())
    //     .subscribe(
    //       data => {
    //         this.mensagem = data;
    //         resolve(this.mensagem);
    //       }, err => {
    //         if (err.json().errorMessage) {
    //           alertctrl.setSubTitle(err.json().errorMessage);
    //           alertctrl.present();
    //         } else {
    //           resolve(false);
    //         }
    //       })
    // });

  }
}



// WEBPACK FOOTER //
// ./src/providers/login-service.ts